import { BuddyExportHiddenFields } from '@adornis/bh-matching-export/static/BuddyExportHiddenFields.js';

export const HiddenSortingMachingUserFields = [
  ...BuddyExportHiddenFields,
  'read_terms_of_use',
  'emailRepeat',
  'minSemesterPrerequisite',
  'extraSubjectSonstiges',
  'privacyPolicy',
];
